import { cn } from '@/lib/ui/cn';

interface TextInputProps {
  name: string;
  label?: string;
  required?: boolean;
  // Leave value & onChange undefined and this will be an uncontrolled input
  value?: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  type?: 'text' | 'email' | 'tel' | 'date' | 'hidden';
  placeholder?: string;
  error?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  className?: string;
}

export const TextInput = ({
  name,
  label,
  placeholder = '',
  required = false,
  value,
  onChange,
  readOnly = false,
  type = 'text',
  error = false,
  onKeyDown,
  className,
}: TextInputProps) => {
  // For hidden inputs, just return the input element
  if (type === 'hidden') {
    return (
      <input
        type='hidden'
        name={name}
        value={value || ''}
        onChange={e => onChange?.(e.target.value)}
      />
    );
  }

  return (
    <div>
      {label && (
        <label className='mb-1 block text-sm font-medium'>
          {label}
          {required && '*'}
        </label>
      )}
      <input
        type={type}
        name={name}
        placeholder={placeholder ? `${placeholder}${required ? '*' : ''}` : ''}
        value={typeof value === 'undefined' ? undefined : value || ''}
        onChange={
          typeof onChange === 'undefined'
            ? undefined
            : e => onChange?.(e.target.value)
        }
        required={required}
        readOnly={readOnly}
        disabled={readOnly}
        className={cn('sh-input', { 'outline-sh-orange': error }, className)}
        onKeyDown={onKeyDown}
      />
    </div>
  );
};
